/**
 * The fields of the task page's dialogs, owned by the page so that a reload
 * never resets them: reason, priority, the approve-or-edit fields, the
 * GitHub links, the reference, the prerequisites and the submitted document.
 */

import { useState } from 'react';

import type { DataRoomDocumentSummary } from '../../api.js';
import type { DependencyCandidates } from '../../components.js';

export type TaskDialogFields = ReturnType<typeof useTaskDialogFields>;

export function useTaskDialogFields() {
  // Dialog fields.
  const [reason, setReason] = useState('');
  const [priority, setPriority] = useState<string | null>(null);
  const [requiresMerge, setRequiresMerge] = useState(false);
  const [editType, setEditType] = useState<string | null>(null);
  const [editDifficulty, setEditDifficulty] = useState<string | null>(null);
  const [editDescription, setEditDescription] = useState('');
  const [issueUrl, setIssueUrl] = useState('');
  const [pullRequestUrl, setPullRequestUrl] = useState('');
  const [mergeUrl, setMergeUrl] = useState('');
  const [referenceKind, setReferenceKind] = useState<string | null>('MERGE');
  const [referenceUrl, setReferenceUrl] = useState('');
  const [dependencyIds, setDependencyIds] = useState<readonly string[]>([]);
  const [dependencyCandidates, setDependencyCandidates] =
    useState<DependencyCandidates>({ status: 'loading' });
  // '' means "no document" — the picker's explicit first choice.
  const [submitDocumentId, setSubmitDocumentId] = useState<string | null>('');
  // The optional note a submission or a direct completion carries.
  const [note, setNote] = useState('');
  // Edit-dialog fields the approve dialog has no use for.
  const [editTitle, setEditTitle] = useState('');
  const [editSuggestedPriority, setEditSuggestedPriority] = useState<string | null>(
    null,
  );
  const [editPriority, setEditPriority] = useState<string | null>(null);
  const [editUnassign, setEditUnassign] = useState(false);
  const [documentChoices, setDocumentChoices] = useState<
    readonly DataRoomDocumentSummary[]
  >([]);

  return {
    reason,
    setReason,
    priority,
    setPriority,
    requiresMerge,
    setRequiresMerge,
    editType,
    setEditType,
    editDifficulty,
    setEditDifficulty,
    editDescription,
    setEditDescription,
    issueUrl,
    setIssueUrl,
    pullRequestUrl,
    setPullRequestUrl,
    mergeUrl,
    setMergeUrl,
    referenceKind,
    setReferenceKind,
    referenceUrl,
    setReferenceUrl,
    dependencyIds,
    setDependencyIds,
    dependencyCandidates,
    setDependencyCandidates,
    submitDocumentId,
    setSubmitDocumentId,
    note,
    setNote,
    editTitle,
    setEditTitle,
    editSuggestedPriority,
    setEditSuggestedPriority,
    editPriority,
    setEditPriority,
    editUnassign,
    setEditUnassign,
    documentChoices,
    setDocumentChoices,
  };
}
